/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

const USER_DATA = 'population-test/auth/USER_DATA';

const initialState = {
  uid: '',
  fullname: '',
  email: '',
  roles: [],
  isLoading: true,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_DATA:
      return {
        ...state,
        uid: action.payload.uid,
        fullname: action.payload.fullname,
        email: action.payload.email,
        roles: state.roles.concat(action.payload.roles),
        isLoading: action.payload.isLoading, 
      };
    default:
      return state;
  }
}

export function isAuthenticated(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

export function setUserData(uid, fullname, email, roles, isLoading) {
  return {
    type: USER_DATA,
    payload: {
      uid,
      fullname,
      email,
      roles,
      isLoading,
    },
  };
}
